<!-- backend/src/components/Cards/CardRollerTable.svelte -->

<script>
  import { roleList,  rpList } from '../../Api.svelte';
  import { onMount } from 'svelte';
  import { usersStore,  selectedRolles, isRoleEditing } from '../../stores/stores';

  export let color = "light";

  let roles = [];
  let rolePriveligesMap = {};

  onMount(async () => {
    roles = await roleList();
    
    await loadRolesPermision(roles);
  });

  async function loadRolesPermision(roles) {
    const permissionPromises = roles.map(async (role) => {
      const permissions = await rpList(role._id);
      if (permissions !== false) {
        rolePriveligesMap[role._id] = permissions;
      } else {
        console.error(`Kullanıcı yetkileri alınamadı: ${role.id}`);
        rolePriveligesMap[role._id] = [];
      }
    });

    await Promise.all(permissionPromises);  // Tüm API çağrılarını bekle
  }
  // console.log(rolePriveligesMap);

  async function deleteRole(id) {
    const confirmed = confirm("Bu kullanıcıyı silmek istediğinizden emin misiniz?");
    if (confirmed) {
      await roleDell(id);
      // Kullanıcı listesini güncelleyin
      users = users.filter(user => user._id !== id);
      usersStore.set(users);  // Store'u güncelle
    }
  }

  function editRole(role) {
    console.log("editRole çağrıldı:", role);  // Konsol çıktısı ekleyin
    selectedRolles.set(role);
    isRoleEditing.set(true);
  }
</script>



<div class="filter blur relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded {color === 'light' ? 'bg-white' : 'bg-red-800 text-white'}">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg {color === 'light' ? 'text-blueGray-700' : 'text-white'}">
          Kullanıcı Rolleri
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <!-- Users table -->
    <table class="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            No:
          </th>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Role Adı
          </th>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Aktif/Pasif
          </th>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Yetkiler
          </th>
          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        {#each roles as role, i}
        <tr>
          <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left flex items-center">
            <span class="ml-3 font-bold {color === 'light' ? 'text-blueGray-600' : 'text-white'}">
              {i + 1}
            </span>
          </th>
          <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 ">
            {role.role_name}
          </td>
          <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 ">
            <span class={role.is_active ? 'p-2 bg-emerald-500 rounded-full  leading-5 font-semibold uppercase text-white' : 'bg-red-500 rounded-full  text-white'}>
              {role.is_active ? 'Aktif' : 'Pasif'}
            </span>
          </td>
          
          <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs  p-4">
            {#if rolePriveligesMap[role._id]}
              {#each rolePriveligesMap[role._id] as priveliges}
                <button
                  type="button"
                  class="border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-white text-blueGray-600">
                  {priveliges}
                </button>
              {/each}
            {:else}
              <span>Yetkiler yükleniyor...</span>
            {/if}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <button class="text-indigo-600 hover:text-indigo-900" on:click="{() => editRole(role)}">Düzenle</button>
            <button class="ml-2 text-red-600 hover:text-red-900" on:click="{() => deleteRole(role.role_id)}">Sil</button>
          </td>
        </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
